import type { RouteRecordRaw } from "vue-router";
import { canUseAiAssistant } from "@/config/router/navigationsGuards/guardAiAssistant";

const MODULE_NAME = "ASSISTANT";

export const guardAskAi = () => {
  return canUseAiAssistant() || { name: "Home" };
};

const assistantRoutes: Array<RouteRecordRaw> = [
  {
    path: "/assistant",
    name: "AskAi",
    component: () => import("@/views/assistant/AskAi.vue"),
    beforeEnter: [guardAskAi],
    meta: {
      requiresAuth: true,
      titleTranslationKey: "pageTitle.askAi",
    },
  },
];

export default assistantRoutes.map((route) => ({
  ...route,
  meta: { ...route.meta, moduleName: MODULE_NAME },
}));
